import RegularLink from './RegularLink.vue';

export default RegularLink;



// WEBPACK FOOTER //
// ./src/components/regularLink/index.ts